// @ utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { get } = require('services/api');
import { generateRoboLanguageParameter } from 'utilities/generateRoboLanguageParameter';
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');
const { SUITABILITY_TEST_ALL_PRODUCTS } = require('constants/RAConstants/index');

const resetPortfolio = () => ({
    type: actionTypes.RA_PORTFOLIO_DISTRIBUTION_RESET_PORTFOLIO,
});

const portfolioDistributionFailure = error => ({
    type: actionTypes.RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_FAILURE,
    payload: {
        error,
    },
});

const portfolioDistributionSuccess = data => ({
    type: actionTypes.RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_SUCCESS,
    payload: {
        portfolio: data.products,
    },
});

const requestPortfolioDistributionInProgress = () => ({
    type: actionTypes.RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_REQUEST,
});

const requestPortfolioDistribution =
    (accessToken, weightDecimals = 4) =>
    dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
                language: generateRoboLanguageParameter(),
            },
            query: {
                weightDecimals,
            },
        };
        const params = {
            // Any value different than Profile Ids [1,2,3,4,5] to bring all products in this case 0
            category: SUITABILITY_TEST_ALL_PRODUCTS,
            language: generateRoboLanguageParameter(),
        };

        dispatch(requestPortfolioDistributionInProgress());

        return get(apiURLBuilder.getURL('raPortfolioDistribution', params), requestData)
            .then(response => dispatch(portfolioDistributionSuccess(response.body)))
            .catch(error => {
                if (error.error) {
                    dispatch(portfolioDistributionFailure(error.error.description));
                } else {
                    throw error;
                }
            });
    };

export default {
    requestPortfolioDistribution,
    resetPortfolio,
};
